module.exports = __webpack_public_path__ + "img/btn_download_app.e2558dd0.svg";